var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        $(document).ready(function () {
            var SHOWN_COOKIE = 'tg-leave-popup-shown';
            var $modal = $('#tgLeavePopup');
            var $content = $modal.find('.tg-leave-popup');

            if (!$modal.length || !$content.length) {
                return;
            }

            var config = parseConfig($content.data('config'));
            var $cityButtons = $content.find('.js_tg-leave-popup-city');
            var $starButtons = $content.find('.js_tg-leave-popup-star');
            var $minInput = $content.find('.js_tg-leave-popup-budget-min');
            var $maxInput = $content.find('.js_tg-leave-popup-budget-max');
            var $rangeRoot = $content.find('.js_tg-leave-popup-range');
            var $minRange = $content.find('.js_tg-leave-popup-range-min');
            var $maxRange = $content.find('.js_tg-leave-popup-range-max');
            var $activeRange = $content.find('.js_tg-leave-popup-range-active');
            var $submitButton = $content.find('.js_tg-leave-popup-btn');

            if (!$minInput.length || !$maxInput.length || !$rangeRoot.length || !$minRange.length || !$maxRange.length || !$activeRange.length || !$submitButton.length) {
                return;
            }

            var state = {
                budgetMin: normalizeBudgetValue(config.defaultBudgetMin, 0, config.absoluteBudgetMax),
                budgetMax: normalizeBudgetValue(config.defaultBudgetMax, 0, config.absoluteBudgetMax)
            };
            var isSubmitRequestPending = false;
            var isProgrammaticSubmitClick = false;
            var requestCounter = 0;

            function parseConfig(rawConfig) {
                var defaultConfig = {
                    requestUrl: '',
                    defaultBudgetMin: 0,
                    defaultBudgetMax: 500000,
                    absoluteBudgetMax: 2000000,
                    pageCrmId: null
                };

                if (!rawConfig) {
                    return defaultConfig;
                }

                if ((typeof rawConfig === "undefined" ? "undefined" : _typeof(rawConfig)) === 'object') {
                    return $.extend({}, defaultConfig, rawConfig);
                }

                try {
                    return $.extend({}, defaultConfig, JSON.parse(rawConfig));
                } catch (e) {
                    return defaultConfig;
                }
            }

            function isMobile() {
                return Boolean(window.app && window.app.isMobile);
            }

            function sendEvent(name) {
                if (window.brxTracking && typeof window.brxTracking.sendAnalyticsEvent === 'function') {
                    window.brxTracking.sendAnalyticsEvent(name);
                }
            }

            function normalizeBudgetValue(value, minValue, maxValue) {
                var normalizedValue = parseDigits(value);

                if (normalizedValue < minValue) {
                    return minValue;
                }

                if (normalizedValue > maxValue) {
                    return maxValue;
                }

                return normalizedValue;
            }

            function parseDigits(value) {
                var digits = String(value || '').replace(/[^\d]/g, '');

                return digits === '' ? 0 : parseInt(digits, 10);
            }

            function formatBudget(value) {
                return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
            }

            function getPercent(value) {
                if (!config.absoluteBudgetMax) {
                    return 0;
                }

                return value / config.absoluteBudgetMax * 100;
            }

            function renderBudget() {
                $minInput.val(formatBudget(state.budgetMin));
                $maxInput.val(formatBudget(state.budgetMax));
                $minRange.val(String(state.budgetMin));
                $maxRange.val(String(state.budgetMax));
                $activeRange.css({
                    left: getPercent(state.budgetMin) + '%',
                    width: getPercent(state.budgetMax) - getPercent(state.budgetMin) + '%'
                });
            }

            function setSubmitHref(url) {
                $submitButton.attr('href', url || '#');
            }

            function invalidateSubmitHref() {
                setSubmitHref('#');
            }

            function setSubmitLoading(isLoading) {
                $submitButton.toggleClass('is-loading', isLoading);
            }

            function setBudgetMin(value, keepRangeOrder) {
                var nextValue = normalizeBudgetValue(value, 0, state.budgetMax);
                state.budgetMin = keepRangeOrder ? nextValue : Math.min(nextValue, state.budgetMax);

                if (state.budgetMin > state.budgetMax) {
                    state.budgetMax = state.budgetMin;
                }

                renderBudget();
                invalidateSubmitHref();
            }

            function setBudgetMax(value, keepRangeOrder) {
                var nextValue = normalizeBudgetValue(value, state.budgetMin, config.absoluteBudgetMax);
                state.budgetMax = keepRangeOrder ? nextValue : Math.max(nextValue, state.budgetMin);

                if (state.budgetMax < state.budgetMin) {
                    state.budgetMin = state.budgetMax;
                }

                renderBudget();
                invalidateSubmitHref();
            }

            function handleBudgetInputTyping($input) {
                var digits = String($input.val() || '').replace(/[^\d]/g, '');

                $input.val(digits === '' ? '' : formatBudget(parseInt(digits, 10)));
            }

            function commitBudgetMinInput() {
                setBudgetMin(parseDigits($minInput.val()), false);
            }

            function commitBudgetMaxInput() {
                setBudgetMax(parseDigits($maxInput.val()), false);
            }

            function getRangeStep() {
                var parsedStep = parseInt($minRange.attr('step') || $maxRange.attr('step') || '1000', 10);

                return isFinite(parsedStep) && parsedStep > 0 ? parsedStep : 1000;
            }

            function normalizeRangeClickValue(rawValue) {
                var step = getRangeStep();
                var snappedValue = Math.round(rawValue / step) * step;

                return normalizeBudgetValue(snappedValue, 0, config.absoluteBudgetMax);
            }

            function moveNearestThumb(clickedValue) {
                var minDistance = Math.abs(clickedValue - state.budgetMin);
                var maxDistance = Math.abs(clickedValue - state.budgetMax);

                if (minDistance <= maxDistance) {
                    setBudgetMin(clickedValue, false);
                    return;
                }

                setBudgetMax(clickedValue, false);
            }

            function selectCity($buttonToActivate) {
                $cityButtons.each(function () {
                    var $button = $(this);
                    $button.toggleClass('is-active', $button.is($buttonToActivate));
                });

                invalidateSubmitHref();
            }

            function getSelectedCityId() {
                var $selectedButton = $cityButtons.filter('.is-active').first();

                return $selectedButton.length ? $selectedButton.data('city-id') || '' : '';
            }

            function getSelectedStars() {
                return $starButtons.filter('.is-active').map(function () {
                    return $(this).data('stars');
                }).get().sort(function (left, right) {
                    return parseInt(left, 10) - parseInt(right, 10);
                });
            }

            function getRequestParams() {
                var params = {
                    cityId: getSelectedCityId(),
                    stars: getSelectedStars(),
                    budgetMin: state.budgetMin,
                    budgetMax: state.budgetMax
                };

                if (config.pageCrmId) {
                    params.pageCrmId = config.pageCrmId;
                }

                return params;
            }

            function requestTelegramUrl(onComplete) {
                var currentRequestId = ++requestCounter;

                $.ajax({
                    url: config.requestUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: getRequestParams()
                }).done(function (response) {
                    var redirectUrl = response && response.success === true ? response.url : '';

                    if (currentRequestId !== requestCounter) {
                        return;
                    }

                    setSubmitLoading(false);

                    if (!redirectUrl) {
                        onComplete('');
                        return;
                    }

                    setSubmitHref(redirectUrl);
                    onComplete(redirectUrl);
                }).fail(function () {
                    if (currentRequestId !== requestCounter) {
                        return;
                    }

                    setSubmitLoading(false);
                    onComplete('');
                });
            }

            $('body').on('mouseleave.tgLeavePopup', function (e) {
                if (isMobile() || $.cookie(SHOWN_COOKIE)) {
                    return;
                }
                // курсор ушёл за верхнюю границу окна
                if (e.clientY >= 10) {
                    return;
                }
                // не перекрываем уже открытую модалку
                if ($('.modal.in').length) {
                    return;
                }

                $modal.modal({ show: true });
                sendEvent('tg_subscribe_leave_open');
                $.cookie(SHOWN_COOKIE, '1', { expires: 10, path: '/' });
            });

            // Ручное открытие из шапки: cookie SHOWN_COOKIE намеренно НЕ ставим,
            // чтобы штатный exit-intent (mouseleave) продолжил срабатывать как обычно.
            $(document).on('click', '.js-tg-leave-popup-open', function (event) {
                event.preventDefault();

                if (isMobile()) {
                    return;
                }

                $modal.modal({ show: true });
                sendEvent('tg_subscribe_menu_open');
            });

            $modal.on('click', '.js_tg-leave-popup-btn', function (event) {
                if (isProgrammaticSubmitClick && $submitButton.attr('href') !== '#') {
                    isProgrammaticSubmitClick = false;
                    return;
                }

                event.preventDefault();

                if (isSubmitRequestPending) {
                    return;
                }

                sendEvent('tg_subscribe_leave_click');
                isSubmitRequestPending = true;
                setSubmitLoading(true);

                requestTelegramUrl(function (redirectUrl) {
                    isSubmitRequestPending = false;

                    if (!redirectUrl) {
                        return;
                    }

                    isProgrammaticSubmitClick = true;
                    $submitButton.get(0).click();
                });
            });

            $cityButtons.on('click', function () {
                selectCity($(this));
            });

            $starButtons.on('click', function () {
                $(this).toggleClass('is-active');
                invalidateSubmitHref();
            });

            $minRange.on('input', function () {
                setBudgetMin($minRange.val(), false);
            });

            $maxRange.on('input', function () {
                setBudgetMax($maxRange.val(), false);
            });

            $rangeRoot.on('click', function (event) {
                if (event.target === $minRange.get(0) || event.target === $maxRange.get(0)) {
                    return;
                }

                var rangeRect = $rangeRoot.get(0).getBoundingClientRect();
                var clickRatio = rangeRect.width > 0 ? (event.clientX - rangeRect.left) / rangeRect.width : 0;
                var normalizedRatio = Math.min(Math.max(clickRatio, 0), 1);
                var clickedValue = normalizeRangeClickValue(normalizedRatio * config.absoluteBudgetMax);

                moveNearestThumb(clickedValue);
            });

            $minInput.on('focus', function () {
                this.select();
            });

            $maxInput.on('focus', function () {
                this.select();
            });

            $minInput.on('input', function () {
                handleBudgetInputTyping($minInput);
            });

            $maxInput.on('input', function () {
                handleBudgetInputTyping($maxInput);
            });

            $minInput.on('blur', function () {
                commitBudgetMinInput();
            });

            $maxInput.on('blur', function () {
                commitBudgetMaxInput();
            });

            $minInput.on('keydown', function (event) {
                if (event.key === 'Enter') {
                    commitBudgetMinInput();
                    $minInput.blur();
                }
            });

            $maxInput.on('keydown', function (event) {
                if (event.key === 'Enter') {
                    commitBudgetMaxInput();
                    $maxInput.blur();
                }
            });

            renderBudget();
            invalidateSubmitHref();
        });
    }, {}] }, {}, [1]);